import { createSupplier } from './states';

export const services = {
  createSupplier,
};
